module.exports = __webpack_public_path__ + "static/img/img_form@2x.e06a3230.png";